/** @jsx jsx */

import { useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as _interactionContext } from './interactionContext';
import {
  MultichoiceImageContext,
  TMultichoiceImageContextValue,
} from './MultichoiceImage';
import EditableBtn from 'components/lib/EditableBtn';

const SubmitBtn = props => {
  const { children } = props;

  const multichoiceImageContext = useContext(
    MultichoiceImageContext
  ) as TMultichoiceImageContextValue;

  const { isLive, isResolved, onSubmit } = multichoiceImageContext;

  return (
    <div
      css={css`
        margin-top: 20px;
        ${!window.dev() &&
          `
          opacity: ${isLive && !isResolved ? 1 : 0};
          pointer-events: ${isLive && !isResolved ? 'auto' : 'none'};
          transition: opacity 0.2s;
        `}
      `}
    >
      <EditableBtn
        {...{ enabled: isLive && !isResolved, ...props }}
        onClick={onSubmit}
      >
        {children}
      </EditableBtn>
    </div>
  );
};

export default SubmitBtn;
